export default __webpack_public_path__ + "static/media/444.039d800e.jpg";